"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.user.transcriptions': 'User Transcriptions',
    'conversation.user.speaking': 'User Speaking',
    'conversation.user.silent': 'User Silent',
};
